module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-bayron-man"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "section--light poster"
  }, [_c('header', {
    staticClass: "poster__header"
  }, [_c('svg', {
    staticClass: "logo-animated",
    attrs: {
      "id": "logo-animated",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 894.294 870.151"
    }
  }, [_c('path', {
    staticClass: "bottle",
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M490.141,559.871c.042-10.789,2.054-25.236,5.13-37.571,1.489-5.966,36.551-146.926,36.551-207.754,0-61.147-12.013-97.891-12.52-99.425a8.19,8.19,0,0,0-7.778-5.612H390.477a8.2,8.2,0,0,0-8.039,6.59c-.5,2.5-12.26,61.743-12.26,98.442,0,60.828,35.066,201.788,36.56,207.759,5.186,20.779,7.343,47.546,2.158,52.736-14.1,14.1-14.5,28.414-14.5,30a8.2,8.2,0,0,0,8.2,8.2h96.832a8.186,8.186,0,0,0,8.2-8.2c0-1.588-.426-15.907-14.512-30Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M68.672,178.092c-.228.8-1.37,5.368-2.4,10.05s-2.512,11.078-3.426,14.275c-9.022,33.918-10.164,59.271-3.312,77.315C64.675,293.666,67.53,298.8,69.7,298.8c2.741.114,13.933-18.044,18.5-30.15,7.309-18.843,7.652-20.557,7.652-38.372.114-17.93-.114-18.729-7.652-33.918a53.656,53.656,0,0,0-10.164-13.476c-6.51-6.281-8.679-7.309-9.365-4.8Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M823.782,181.519c-8.679,8.223-13.248,15.075-17.016,26.267-3.312,9.593-3.54,34.375-.457,44.882,5.824,19.986,20.1,46.709,24.439,45.91,1.6-.228,6.167-8.223,9.136-15.646,2.512-6.51,5.824-24.554,5.824-31.977,0-8.794-3.312-28.208-8.565-49.107-.8-3.426-2.512-10.392-3.655-15.3-1.256-5.025-2.627-9.25-3.312-9.479-.571-.228-3.426,1.827-6.4,4.454Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M13.855,262.032c-1.142,1.142-.8,14.275.457,21.013.685,3.426,1.713,10.278,2.284,15.3,2.512,22.955,9.136,46.709,17.587,63.383,6.51,13.019,21.47,28.437,27.751,28.551,2.17,0,2.512-.8,3.312-7.766,1.827-17.587-.8-46.823-6.053-65.324-6.966-25.01-20.1-44.882-33.69-51.163C17.4,262.374,14.54,261.346,13.855,262.032Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M881.111,263.059c-9.936,3.2-20.9,12.9-27.751,24.325-13.476,22.726-21.013,60.413-18.5,92.619.914,11.649,1.941,12.562,8.908,7.766,16.445-11.42,26.609-29.236,34.261-59.728,3.2-12.448,5.368-23.983,5.368-27.409a100.66,100.66,0,0,1,1.713-12.334,115.987,115.987,0,0,0,1.713-17.473c0-8.908-.457-9.479-5.71-7.766Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M118.807,317.991C103.733,336.949,89.8,363.9,83.633,385.713c-4.8,16.674-5.368,20.442-5.368,35.517,0,19.529,2.17,26.838,11.306,38.6,3.654,4.682,4,4.8,5.482,2.855,1.6-2.17,19.757-38.943,22.955-46.138.914-2.17,2.4-5.482,3.2-7.195a14.555,14.555,0,0,0,1.6-5.025,12.553,12.553,0,0,1,1.6-4.682c1.713-3.312,4-10.621,6.738-21.356,4.454-17.359,5.368-33.347,2.627-46.252-1.6-7.994-6.966-20.557-8.794-20.557C124.4,311.481,121.662,314.451,118.807,317.991Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M772.961,314.565c-4.454,6.738-8.337,22.612-8.337,33.461.114,10.963,4.111,32.662,7.537,40.885a18.508,18.508,0,0,1,1.6,5.368,18.507,18.507,0,0,0,1.6,5.368c.914,2.056,2.741,6.624,4.111,10.05,6.852,17.13,25.125,53.675,26.838,53.675,3.083,0,10.164-10.621,13.59-20.328,1.713-4.8,2.17-9.479,2.056-21.47,0-16.217-1.37-24.1-6.738-39.857-1.6-4.454-3.2-9.593-3.769-11.42-4.111-13.362-31.748-58.814-35.86-58.814-.343,0-1.6,1.37-2.627,3.083Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M3.577,350.082c-1.37,1.256-.685,23.64,1.142,35.517,2.17,15.3,4.8,28.893,6.852,35.517,2.969,9.936,6.167,19.529,7.195,21.47,5.139,10.164,6.852,13.248,11.078,19.757,5.139,7.766,22.5,25.353,27.066,27.294,1.37.685,4.682,2.512,7.423,4.111,7.081,4.111,8.451,3.2,7.537-4.911-1.941-19.643-9.821-54.246-16.1-70.577-.914-2.512-2.512-6.624-3.54-9.136A127.06,127.06,0,0,0,44.8,393.136c-7.994-13.248-12.677-19.529-19.529-26.723-7.994-8.223-20.442-17.7-21.7-16.331Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M887.964,355.107c-10.164,7.652-15.075,12.562-22.27,22.155-14.39,18.958-25.01,45.567-31.863,79.257-2.512,12.334-5.025,27.066-5.71,33.461-.8,7.195.685,7.652,9.25,2.969,13.7-7.537,27.523-21.128,36.545-35.86,2.4-3.883,9.479-18.843,9.479-19.986a20.172,20.172,0,0,1,1.6-4.8c3.54-8.223,7.309-24.668,10.392-45.11,1.827-12.106,2.4-36.431.914-37.23-.571-.343-4.226,2.056-8.337,5.139Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M124.517,439.845a22.706,22.706,0,0,0-1.713,7.081,58.818,58.818,0,0,1-1.941,10.05c-2.855,10.735-2.855,61.784,0,73.775,5.025,20.442,7.423,27.18,14.5,42.255,6.852,14.618,21.356,36.545,24.1,36.545,2.512,0,5.71-9.022,7.88-22.27a79.217,79.217,0,0,1,2.4-10.849c2.284-8.223,1.941-52.191-.571-61.67-5.824-22.27-11.649-37.116-18.958-48.536a57.731,57.731,0,0,1-3.312-5.71c-1.827-3.769-17.7-23.754-19.3-24.325-.8-.228-2.17,1.37-3.083,3.655Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M764.853,444.756c-6.852,8.565-16.445,23.183-18.615,28.208a45.882,45.882,0,0,1-2.056,4.111c-4.111,6.966-9.593,22.955-13.362,38.715-2.4,10.278-2.741,51.049-.457,59.5.8,2.855,1.827,7.994,2.4,11.42,1.6,10.507,4.911,20.785,6.966,22.155,1.6.914,2.4.685,3.769-1.028,2.17-2.855,12.105-17.587,13.819-20.557,3.083-5.253,13.019-25.581,13.019-26.723a19.032,19.032,0,0,1,1.6-4.911C780.27,536,783.925,504.6,781.3,475.363c-.914-10.05-2.284-20.1-2.855-22.27a29.724,29.724,0,0,1-1.256-7.423c0-3.769-2.17-8.679-4.111-9.365-.685-.228-4.454,3.54-8.223,8.451Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M3.577,480.273c-1.028,1.6,3.883,16.9,8.794,27.637,8.108,17.93,25.581,35.4,48.422,48.536,4.911,2.855,9.707,5.71,10.621,6.281,7.309,4.34,45.224,22.841,46.937,22.841,1.941,0,2.17-.571,1.6-4.34-1.256-7.423-4.111-15.76-9.365-27.066-8.451-18.387-26.5-36.088-52.3-51.62C52.341,499,31.442,489.181,21.164,485.07a95.449,95.449,0,0,1-9.479-4.111C8.031,479.131,4.49,478.9,3.577,480.273Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M887.964,481.3c-2.17,1.028-5.71,2.512-7.652,3.312-8.451,3.54-11.991,5.025-15.532,6.51-5.482,2.4-19.3,9.479-23.754,12.106-2.17,1.37-4.682,2.741-5.6,3.2-1.6.685-5.253,3.312-15.417,10.849-6.281,4.8-19.986,19.3-23.983,25.467-4.454,7.081-11.991,22.726-11.991,25.01a23.273,23.273,0,0,1-1.713,5.6c-2.284,5.368-2.284,12.22-.114,12.22,1.37,0,43.283-20.785,53.219-26.381,20.9-11.877,39.514-28.551,48.765-43.854,5.71-9.365,13.819-32.434,12.334-34.832-1.028-1.6-3.883-1.256-8.565.8Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M29.843,569.466c-.685,1.028.343,4.8,1.485,5.824.343.343,1.941,2.4,3.54,4.568,13.933,19.986,41,45.567,59.957,56.645,3.083,1.827,6.738,3.883,7.994,4.682a49.611,49.611,0,0,0,4.911,2.627c1.485.571,5.253,2.284,8.565,3.769,16.674,7.652,32.548,11.763,54.475,14.5,12.334,1.485,12.562,1.485,12.562-.571,0-2.284-11.877-20.328-19.986-30.264-9.022-10.963-33.119-32.89-39.4-35.745-.914-.457-3.2-1.827-5.139-3.083-4.911-3.083-16.674-9.25-19.986-10.278-1.6-.571-5.6-2.056-9.022-3.312-9.365-3.54-23.3-6.624-36.659-8.108C31.785,568.438,30.528,568.324,29.843,569.466Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M861.7,569.123c-32.548,2.969-47.623,6.738-69.093,17.245-16.331,8.108-27.066,15.646-40.77,29.236-16.217,15.874-37.459,44.539-34.946,47.166.914.8,21.013-1.485,31.177-3.655,17.93-3.769,28.322-7.423,45.11-15.874,7.537-3.769,23.526-13.59,25.125-15.417.343-.343,2.855-2.4,5.71-4.568,12.105-9.136,27.409-25.01,38.715-39.971,8.794-11.763,9.593-13.362,7.423-14.161a8.064,8.064,0,0,0-3.083-.457c-.8,0-3.2.343-5.368.457Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M185.159,573.805c-2.17,2.284,2.627,31.177,7.423,45.453a68.312,68.312,0,0,1,2.17,6.852c2.056,7.195,8.451,22.955,11.42,27.98.571.914,2.284,4.111,3.883,7.081,3.654,6.738,10.392,17.245,12.334,19.3.8.914,3.769,4.454,6.624,7.88a180.224,180.224,0,0,0,38.943,34.6c6.738,4.454,8.908,5.139,9.136,2.741,1.37-15.76-4.8-48.422-12.791-67.608A251.067,251.067,0,0,0,253,635.247c-1.256-1.941-2.627-4.226-3.083-5.139C248.085,626,238.149,614,229.7,605.44c-8.451-8.451-26.838-23.3-28.779-23.3a5.658,5.658,0,0,1-2.627-1.6c-3.083-2.627-12.448-7.423-13.133-6.738Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M710.378,575.4c-1.827,1.142-4.226,2.512-5.139,2.969s-4,2.284-6.852,4.226c-18.729,12.448-37.687,30.949-47.508,46.366-9.136,14.5-18.272,34.832-21.013,46.823-.457,2.17-1.37,6.281-2.056,9.136-3.312,13.476-4.8,23.754-4.8,32.434,0,5.139.343,9.707.685,10.164,1.713,1.713,25.467-16.1,37.573-28.322,17.016-17.016,27.751-33.233,38.715-58.243,9.136-20.785,18.5-63.383,14.846-66.809C714.261,573.691,712.32,574.262,710.378,575.4Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M110.813,664.482c-7.423.914-14.732,3.312-16.788,5.368a4.524,4.524,0,0,1-2.627,1.37c-1.827,0-6.281,4.911-6.281,7.081,0,1.37,17.016,13.59,23.983,17.245a54.372,54.372,0,0,1,5.139,3.083c1.941,1.256,4.454,2.741,5.71,3.426s5.368,2.969,9.136,5.139c8.223,4.8,34.489,17.7,41.684,20.557,2.855,1.142,6.738,2.627,8.565,3.426a96.756,96.756,0,0,0,9.707,3.2c3.426,1.028,9.365,2.627,13.133,3.769,10.164,2.855,37,2.969,43.968,0,7.766-3.2,8.565-3.655,8.908-5.6.457-2.284-14.39-15.417-32.662-28.665-3.883-2.855-7.309-5.253-7.537-5.253a59.611,59.611,0,0,1-7.195-4.34c-7.081-4.8-8.108-5.368-21.7-11.991-15.3-7.652-28.437-12.9-34.6-14.161-1.6-.343-5.139-1.256-7.994-2.056-6.51-1.941-23.64-2.741-32.548-1.6Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M767.48,664.368a112.665,112.665,0,0,0-27.98,6.966c-3.426,1.256-7.652,2.741-9.25,3.312a30.133,30.133,0,0,0-5.139,2.056c-1.142.685-6.053,3.083-10.735,5.368-21.128,10.278-45.8,27.066-63.383,43.169-7.766,7.195-7.766,8.908,0,11.877,18.272,6.852,49.792,3.083,78.8-9.365,7.195-3.2,19.529-8.794,21.128-9.707.914-.571,5.824-3.083,10.849-5.71,5.025-2.512,10.735-5.71,12.562-6.852,1.941-1.256,4.454-2.741,5.71-3.426s3.883-2.17,5.71-3.426c1.941-1.256,4.226-2.627,5.139-3.083s4.911-2.969,8.908-5.71a66.828,66.828,0,0,1,7.766-4.911,18.644,18.644,0,0,0,3.883-2.512c5.025-3.655,4.454-6.624-2.17-10.963-3.2-1.941-6.281-3.655-6.966-3.655a13.693,13.693,0,0,1-4.34-1.6C794.089,664.254,777.872,663.226,767.48,664.368Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M294.68,668.365a38.175,38.175,0,0,1-4.226,1.028c-4.111.914-4.111,3.769-.228,9.479a67.389,67.389,0,0,1,4,6.624,57.735,57.735,0,0,0,3.312,5.71c1.256,1.827,2.741,4.454,3.426,5.71s2.17,3.769,3.426,5.71c1.256,1.827,2.741,4.454,3.426,5.71s2.056,3.655,3.2,5.368c1.028,1.713,4,6.281,6.4,10.278,11.192,17.93,28.893,38.258,41.8,48.194,7.88,6.053,19.072,11.306,28.094,13.133,9.022,1.941,12.334,1.37,12.791-1.941.571-3.54-3.54-17.13-8.337-28.208a138.552,138.552,0,0,0-12.22-23.183,31.843,31.843,0,0,1-3.2-5.482c0-.343-3.769-5.6-8.451-11.649C353.494,696,335.108,679.9,320.946,673.619c-7.537-3.312-22.841-6.4-26.267-5.253Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M590.465,670.078c-11.991,3.083-15.417,4.8-28.551,14.5-14.846,10.849-30.721,29.122-42.483,48.879-2.4,4-12.562,25.01-14.39,29.693-2.855,7.423-5.71,19.643-5.025,21.584.914,2.17,5.6,2.284,14.5.228,21.927-4.8,44.882-25.239,67.608-60.071,4.682-7.195,19.529-31.634,20.671-34.261a54.369,54.369,0,0,1,3.083-5.139c1.256-1.941,2.627-4.226,3.083-5.139a23.325,23.325,0,0,1,2.741-4.34c2.741-3.54,1.713-5.6-3.312-7.081-5.6-1.485-8.451-1.37-17.93,1.142Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M197.607,754.589c-3.769.571-10.392,1.6-14.846,2.17-26.5,3.883-46.481,16.331-53.9,33.461-.8,1.713-1.028,3.312-.571,3.54,1.6.914,21.813,4.226,37.344,6.053,22.841,2.855,73.775,2.855,87.365,0,21.813-4.454,38.144-11.42,47.737-20.442,6.4-6.167,7.195-8.108,3.769-9.821-4.682-2.627-24.668-7.994-39.514-10.849-21.356-4-54.589-6.053-67.38-4.111Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M673.262,754.018c-.914.228-7.88,1.028-15.417,1.713a241.27,241.27,0,0,0-35.974,5.939c-2.855.685-6.966,1.6-9.136,2.056-8.908,2.056-19.414,6.4-19.414,8.108,0,1.485,8.108,9.707,13.133,13.133,4.454,2.969,16.1,8.565,20.557,9.707,1.941.457,5.025,1.37,6.852,1.941a126.872,126.872,0,0,0,14.275,3.2c14.961,2.855,63.383,2.855,86.223,0,18.387-2.17,36.2-5.253,37.459-6.281,2.969-2.627-11.649-21.013-20.214-25.239-2.512-1.37-5.482-2.855-6.4-3.312-5.939-3.426-20.442-7.423-33.69-9.25C702.041,754.474,676.231,753.218,673.262,754.018Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M335.222,796.387c-13.933,2.4-26.152,5.025-31.406,6.852a28.546,28.546,0,0,1-6.51,1.6,18.25,18.25,0,0,0-5.71,1.6c-2.056.914-6.053,2.512-8.908,3.54-37,14.39-61.784,37.116-64.525,59.271-.685,4.911-.457,6.4.685,6.4,2.284,0,27.523-4.568,41.57-7.537a82.822,82.822,0,0,1,10.278-1.6c2.17,0,9.479-1.485,25.125-5.368q50.363-12.163,73.889-33c9.593-8.451,21.813-26.838,19.414-29.236C384.9,794.674,354.408,793.189,335.222,796.387Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M516.8,796.615c-3.426,1.142-6.281,2.512-6.281,3.083,0,.685,1.6,4.226,3.426,7.88,4.111,8.108,16.559,21.813,25.125,27.523,6.51,4.226,23.754,13.476,27.523,14.618,1.142.343,5.824,1.827,10.164,3.426,7.423,2.512,10.507,3.426,26.952,8.108a46.341,46.341,0,0,0,8.565,1.827,72.106,72.106,0,0,1,9.593,1.6c15.075,3.426,24.668,5.253,27.18,5.253a60.828,60.828,0,0,1,9.707,1.6c10.849,2.512,23.64,4.568,24.211,3.883.8-.8-2.17-13.019-4.226-17.473C672.463,844.009,656.132,828.478,639,819.8c-2.855-1.37-5.939-2.969-6.852-3.426a143.993,143.993,0,0,0-14.275-6.167c-2.512-.914-6.624-2.4-9.136-3.426-27.637-10.164-75.031-15.417-91.933-10.164Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M428.3,819.684c-3.769,1.941-9.25,4.911-12.22,6.624C398.262,836.7,384.1,853.6,382.959,865.936l-.343,3.426,6.966.343c9.022.457,18.158-3.655,25.81-11.42,6.167-6.281,11.306-16.217,20.442-39.514C437.091,815.459,436.405,815.573,428.3,819.684Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M465.413,820.484a148.39,148.39,0,0,0,5.6,14.961c.571,1.028,2.284,4.454,3.769,7.423,4.682,9.821,5.482,10.849,12.22,17.016,7.88,7.081,15.075,10.05,24.439,10.05h6.738l-.8-4.568a38.746,38.746,0,0,0-3.54-9.479c-1.485-2.627-3.2-5.824-3.769-7.081-2.512-5.71-19.072-18.958-33.461-26.723-10.507-5.71-12.562-5.939-11.192-1.6Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "fill": "none",
      "stroke": "#bea060",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "cx": "448.147",
      "cy": "402.879",
      "r": "377.879"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("Zissel sucht den Bayron-Man 2010!")])]), _vm._v(" "), _c('div', {
    staticClass: "poster__body"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "gewinnspiel"
    }
  }, [_c('span', [_vm._v("zum Gewinnspiel")])])], 1)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "hero--sm"
  }, [_c('h1', {
    staticClass: "hero-heading"
  }, [_vm._v("\n            Bayron-Man 2010\n            "), _c('small', [_vm._v("24. bis 26. September 2010")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--interlude"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-8"
  }, [_c('h2', [_vm._v("Der Durstlöscher für Sportler")]), _vm._v(" "), _c('p', [_vm._v("Für Sportler hat Bier einen entscheidenden Vorteil:"), _c('br'), _vm._v("\n                        Mit seinem hohen Wassergehalt und der relativ niedrigen Alkoholkonzentration\n                        ersetzt das Bier quasi als "), _c('b', [_vm._v("isotonischer Durstlöscher")]), _vm._v(" schnell die verlorene\n                        Flüssigkeit. Die leicht verfügbaren Kohlenhydrate machen den Energieverlust\n                        durch den Sport wieder wett. Besonders eignet sich hierfür "), _c('b', [_vm._v("alkoholfreies\n                        Bier oder Leichtbier.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("3 Kilometer Schwimmen auf dem Main,")]), _vm._v(" "), _c('li', [_vm._v("90 Kilometer auf dem Rad und")]), _vm._v(" "), _c('li', [_vm._v("21 Kilometer Laufen durch das Frankenland")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("heißt am"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "em"
  }, [_vm._v("Sonntag, 26. September 2010")]), _c('br'), _vm._v("\n                die sportliche Herausforderung.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Und für alle, die lieber feiern oder die mehr als 1000 Läufer anfeuern wollen,\n                organisiert Zissel ein ganzes Wochenende mit Partyspaß, Events und Live-Musik.\n                Zissel ist immer dabei!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Gewinnen Sie mit Zisselbier.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15deb93d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/bayron-man.vue
// module id = 29
// module chunks = 0